import { render, staticRenderFns } from "./qaList.vue?vue&type=template&id=74e130f4&scoped=true&"
import script from "./qaList.vue?vue&type=script&lang=js&"
export * from "./qaList.vue?vue&type=script&lang=js&"
import style0 from "./qaList.vue?vue&type=style&index=0&id=74e130f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e130f4",
  null
  
)

export default component.exports